import * as CONSTANTS from "../../utilities/Constants";
import { IMeasuredPropertyData } from "../shared/IMeasuredPropertyData";
import { IKeyedInPropertyData } from "../shared/IKeyedInPropertyData";
import { ITestplanBasicData, defaultTestplanBasicData } from "../testplan/TestplanBasicData";
import { ICalculatedPropertyData } from "../shared/ICalculatedPropertyData";
import moment from "moment";
import DateFormatting from "../../utilities/DateFormat";

export interface IGradeViewData {
  id: string;
  name: string;
  description: string;
  code: string;
  isEnabled: boolean;
  state: string;
  testplan: ITestplanBasicData;
  measuredProperties: IMeasuredPropertyData[];
  keyedInProperties: IKeyedInPropertyData[];
  calculatedProperties: ICalculatedPropertyData[];
  testPlanName?: string;
  createdOn?: string;
  formatedDate?: string;
}


export default class GradeViewData implements IGradeViewData {
  id: string;
  name: string;
  description: string;
  code: string;
  isEnabled: boolean;
  state: string;
  testplan: ITestplanBasicData;

  measuredProperties: IMeasuredPropertyData[];
  keyedInProperties: IKeyedInPropertyData[];
  calculatedProperties: ICalculatedPropertyData[];

  testPlanName?: string;
  createdOn?: string;
  formatedDate?: string;

  constructor(
    id: string,
    name: string,
    description: string,
    code: string,
    isEnabled: boolean,
    testplan: ITestplanBasicData,
    measuredProperties: IMeasuredPropertyData[],
    keyedInProperties: IKeyedInPropertyData[],
    calculatedProperties: ICalculatedPropertyData[],
    testPlanName?: string,
    createdOn?: string
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.code= code;
    this.isEnabled= isEnabled;
    this.testplan = testplan;
    this.measuredProperties= measuredProperties;
    this.keyedInProperties= keyedInProperties;
    this.calculatedProperties= calculatedProperties;
    this.state = id !== '' ? isEnabled ? CONSTANTS.ENABLED : CONSTANTS.DISABLED :'';
    this.testPlanName = testPlanName;
    this.createdOn = createdOn
    ? moment.utc(createdOn)
    .utcOffset(DateFormatting.getDateTimeRegionOffset())
    .format(DateFormatting.getDateTimeRegion())
    : createdOn;
  this.formatedDate = createdOn
    ? moment.utc(createdOn)
    .utcOffset(DateFormatting.getDateTimeRegionOffset())
    .format(DateFormatting.getDateTimeRegion())
    : createdOn;
  }
}

const defaultGradeData = new GradeViewData("", "","", "", false, defaultTestplanBasicData,[],[],[]);
export { defaultGradeData };
